'use client'

import * as React from 'react'
import {
  AreaChart,
  Area,
  ResponsiveContainer,
} from 'recharts'
import { cn } from '@/lib/utils'

const COLOR_MAP = {
  lime: 'var(--color-lime)',
  cyan: 'var(--color-cyan)',
  purple: 'var(--color-purple)',
  pink: 'var(--color-pink)',
} as const

export interface SparklineProps {
  data: number[]
  color?: keyof typeof COLOR_MAP
  width?: number | string
  height?: number | string
  fillOpacity?: number
  strokeWidth?: number
  className?: string
}

const Sparkline: React.FC<SparklineProps> = ({
  data,
  color = 'lime',
  width = 96,
  height = 32,
  fillOpacity = 0.1,
  strokeWidth = 2,
  className,
}) => {
  const chartData = React.useMemo(
    () => data.map((val, i) => ({ val, i })),
    [data]
  )

  const strokeColor = COLOR_MAP[color]

  if (!data.length) return null

  return (
    <div className={cn('inline-block', className)} style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData}>
          <Area
            type="monotone"
            dataKey="val"
            stroke={strokeColor}
            fill={strokeColor}
            fillOpacity={fillOpacity}
            strokeWidth={strokeWidth}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}

export { Sparkline }
